import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export default function Combukti({ kodebooking }) {
  const urlapi = process.env.REACT_APP_BASE_URL
  const [bukti, setBukti] = useState([]);
  const [modalShow, setModalShow] = useState(false);

  const getdata = async () => {
    try {
      const response = await axios.get(
        urlapi + "Getbuktipembayaran?kode=" + kodebooking
      );
      setBukti(response.data)

    } catch (error) {

    }
  }

  const showimage = () => {
    getdata();
    setModalShow(true);
  }



  return (
    <div className="booking-btn-secondary-wrapper">
      <Button
        variant="primary rounded-pill"
        onClick={() => showimage()}
        className="booking-btn-secondary"
        style={{ backgroundColor: "#fff", color: "#2b2e5a" }}
      >
        Lihat Bukti Pembayaran
      </Button>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Bukti pembayaran anda
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <center>
            <img src={bukti.bukti} className='img-fluid' style={{ height: '400px' }} />
          </center>
        </Modal.Body>
        <Modal.Footer>
          <Button className='' onClick={() => setModalShow(false)} style={{ backgroundColor: "#2b2e5a", color: "white" }}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
